import { alertStatuses, statisticOrientations, statisticSizes, statisticStatuses } from './constants'

const isLarge = size => size === statisticSizes.large

const isHorizontal = orientation => orientation === statisticOrientations.horizontal

export const isAlertStatus = status => alertStatuses.includes(status)

export const getValueColor = (status, theme) => {
  const valueColors = {
    [statisticStatuses.default]: theme.colors.text.default,
    [statisticStatuses.success]: theme.colors.success.default,
    [statisticStatuses.warning]: theme.colors.warning.default,
    [statisticStatuses.danger]: theme.colors.danger.default,
  }

  return valueColors[status]
}

export const getIconSize = (size, theme) => (isLarge(size) ? theme.size.XS : theme.size.XXS)

export const getGap = (size, theme) => (isLarge(size) ? theme.spacing.sp8 : theme.spacing.sp4)

export const getDataGap = (orientation, size, theme) => {
  if (!isHorizontal(orientation)) return getGap(size, theme)

  return isLarge(size) ? theme.spacing.sp4 : theme.spacing.sp2
}

export const getBodyOffset = (orientation, size, theme) => {
  if (isHorizontal(orientation)) return theme.spacing.sp0

  return isLarge(size) ? theme.spacing.sp4 : theme.spacing.sp2
}

export const getPadding = (orientation, size, theme) => {
  const { sp8, sp12, sp16, sp24 } = theme.spacing

  if (isHorizontal(orientation) && isLarge(size)) return `${sp12} ${sp24} ${sp12} ${sp16}`
  if (isHorizontal(orientation)) return `${sp8} ${sp16} ${sp8} ${sp12}`
  if (isLarge(size)) return sp12

  return `${sp8} ${sp12}`
}

export const getBackgroundColor = ({ isAlert, isOutlined, status, theme }) => {
  if (isAlert) return theme.colors[status].surface
  if (isOutlined) return theme.colors.background.primary

  return 'transparent'
}

export const getBorderShadow = ({ isAlert, isOutlined, status, theme }) => {
  if (isAlert) return `inset 0 0 0 ${theme.stroke.default} ${theme.colors[status].default}`
  if (isOutlined) return `inset 0 0 0 ${theme.stroke.default} ${theme.colors.border.default}`

  return 'none'
}
